import { Pipe, PipeTransform } from '@angular/core';
import {ExpressionModel} from "web-shared";

@Pipe({
  name: 'isExpressionEmpty'
})
export class IsExpressionEmptyPipe implements PipeTransform {

  transform(value: ExpressionModel): boolean {
    return !value || value.isEmpty();
  }
}
